import { createContext, useContext, useState, ReactNode } from "react";

interface DebugConsoleContextType {
    isDebugMode: boolean;
    setIsDebugMode: (isDebugMode: boolean) => void;
}

const DebugConsoleContext = createContext<DebugConsoleContextType | undefined>(
    undefined,
);

export const DebugConsoleProvider = ({ children }: { children: ReactNode }) => {
    const [isDebugMode, setIsDebugMode] = useState(false);

    return (
        <DebugConsoleContext.Provider value={{ isDebugMode, setIsDebugMode }}>
            {children}
        </DebugConsoleContext.Provider>
    );
};

export const useDebugConsole = () => {
    const context = useContext(DebugConsoleContext);
    if (!context) {
        throw new Error(
            "useDebugConsole must be used within a DebugConsoleProvider",
        );
    }
    return context;
};
